
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function CTA() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d3048eavrfupcr1qum7g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString()
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (submitted) {
    return (
      <section className="py-20 bg-emerald-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-check-line text-3xl text-emerald-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">
            Talebiniz Başarıyla Alındı
          </h2>
          <p className="text-xl text-emerald-100 mb-8">
            Uzman ekibimiz en kısa sürede sizinle iletişime geçecek.
          </p>
          <Button 
            variant="outline" 
            className="border-white text-white hover:bg-white hover:text-emerald-600"
            onClick={() => setSubmitted(false)}
          >
            Yeni Teklif İste
          </Button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-emerald-600">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-white mb-6">
              Sürdürülebilirlik Yolculuğunuza Bugün Başlayın
            </h2>
            <p className="text-xl text-emerald-100 mb-8">
              16+ yıllık deneyimimiz ve kanıtlanmış metodolojimizle işletmenizin sürdürülebilirlik hedeflerine ulaşmasına yardımcı oluyoruz.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-emerald-100">Ücretsiz İlk Konsültasyon</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-emerald-100">Uzman Ekip Desteği</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-emerald-100">Özelleştirilmiş Çözümler</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Ücretsiz Teklif Alın
            </h3>
            
            <form id="teklif-formu" onSubmit={handleSubmit} data-readdy-form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="e-posta@ornek.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="+90 5XX XXX XX XX"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Şirket Adı
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="Şirket adınız"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  İlgilendiğiniz Hizmet
                </label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm pr-8"
                >
                  <option value="">Hizmet seçiniz</option>
                  <option value="sustainability">Sürdürülebilirlik Danışmanlığı</option>
                  <option value="esg">ESG Danışmanlığı</option>
                  <option value="gap">GAP Analizi</option>
                  <option value="ecovadis">Ecovadis Danışmanlığı</option>
                  <option value="sbti">SBTi Danışmanlığı</option>
                  <option value="cdp">CDP Raporu</option>
                  <option value="carbon">Karbon Ayak İzi</option>
                  <option value="water">Su Ayak İzi</option>
                  <option value="lca">Yaşam Döngüsü Analizi</option>
                  <option value="other">Diğer</option>
                </select>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mesajınız
                </label>
                <textarea
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                  placeholder="Projeniz hakkında detayları paylaşın..."
                ></textarea>
                <div className="text-xs text-gray-500 mt-1">
                  {formData.message.length}/500 karakter
                </div>
              </div>

              <Button
                type="submit"
                disabled={isSubmitting || formData.message.length > 500}
                className="w-full"
                size="lg"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 flex items-center justify-center mr-2">
                      <i className="ri-loader-4-line animate-spin"></i>
                    </div>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <div className="w-5 h-5 flex items-center justify-center mr-2">
                      <i className="ri-send-plane-line"></i>
                    </div>
                    Ücretsiz Teklif Al
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
